export default [
    {
        routeName: 'offerFlow-steps-twocol-date',
        name: 'offerFlow.accommodation.steps.step1',
    },
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.accommodation.steps.step2',
        skipIfUpsell: true,
    },
    {
        routeName: 'offerFlow-steps-twocol-accommodation-residents',
        name: 'offerFlow.accommodation.steps.step3',
    },
    {
        routeName: 'offerFlow-steps-accommodation-list',
        name: 'offerFlow.accommodation.steps.step4',
    },
    {
        routeName: 'offerFlow-steps-accommodation-details',
        name: 'offerFlow.accommodation.steps.step5',
    },
] as ProductFlowStep[];
